import { useMemo } from 'react';
import { EPermissions } from '@/types/permissions';
import { useNewAuth } from '@/providers/AuthProvider/NewAuthProvider.hooks';
import { useNewFeature } from '@/providers/NewFeatureContextProvider/NewFeatureContext.hooks';

export const usePermissionsManager = () => {
  const { user, isAuthenticated } = useNewAuth();
  const { isAlertingPermitted } = useNewFeature();

  const arePermissionsResolved = !isAuthenticated || user !== null;

  return useMemo(() => {
    const permissions = user?.permissions ?? [];
    // admin:all gives access only to the admin app, not to the modules
    const hasPermission = (permission: EPermissions) => permissions.includes(permission);

    return {
      arePermissionsResolved,
      shouldDisplayRiskMonitoring: hasPermission(EPermissions.MONITORING),
      shouldDisplayAlerting: hasPermission(EPermissions.ALERTING),
      shouldDisplayAlertingSettings: isAlertingPermitted
        ? hasPermission(EPermissions.ALERTING)
        : hasPermission(EPermissions.MONITORING),
      shouldDisplayStablecoins: hasPermission(EPermissions.STABLECOINS),
      shouldDisplayModeling: hasPermission(EPermissions.MODELING),
      shouldDisplayDocumentation: hasPermission(EPermissions.DOCS),
      // the AI assistants (Claude, ChatGPT) the user connected to the MCP server
      shouldDisplayConnectedAssistants: hasPermission(EPermissions.MCP),
    };
  }, [user, arePermissionsResolved, isAlertingPermitted]);
};
